import { el } from "@dhx/ts-common/dom";
import { ICol, IRendererConfig, GridEvents, IRow, IEditor } from "../../types";
import { isNumeric } from "@dhx/ts-common/core";

export class InputEditor implements IEditor {
	protected _handlers: { [key: string]: (...args) => void };
	protected _cell: { row: IRow, col: ICol };
	protected _config: IRendererConfig;
	protected _input: HTMLInputElement;

	constructor(row: IRow, col: ICol, config: IRendererConfig) {
		this._config = config;
		this._cell = { row, col };
		this._initHandlers();
	}

	endEdit(withoutSave?: boolean) {
		let value: any;
		if (!withoutSave) {
			value = this._input.value;
		}
		if (this._config.events.fire(GridEvents.beforeEditEnd, [value, this._cell.row, this._cell.col])) {
			this._input.removeEventListener("blur", this._handlers.onBlur);
			this._input.removeEventListener("change", this._handlers.onChange);
			this._handlers = {};
			if (this._cell.col.type !== "string" && isNumeric(value)) {
				value = parseFloat(value);
			}
			this._config.events.fire(GridEvents.afterEditEnd, [value, this._cell.row, this._cell.col]);
		} else {
			this._input.focus();
		}
	}

	toHTML() {
		let content = this._cell.row[this._cell.col.id];
		if (this._input) {
			content = this._input.value;
		}
		this._config.$editable.editor = this;
		return el("input.dhx_cell-editor.dhx_cell-editor__input", {
			_hooks: {
				didInsert: this._handlers.didInsert
			},
			_key: "cell_editor",
			dhx_id: "cell_editor",
			value: content
		});
	}

	protected _initHandlers() {
		this._handlers = {
			onBlur: () => {
				this.endEdit();
			},
			onChange: () => {
				this.endEdit();
			},
			didInsert: (node: any) => {
				const input = node.el;
				this._input = input;
				input.focus();
				input.setSelectionRange(0, input.value.length);
				input.addEventListener("change", this._handlers.onChange);
				input.addEventListener("blur", this._handlers.onBlur);
			}
		};
	}
}